import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center text-center px-4">
      <div className="w-20 h-20 flex items-center justify-center bg-background-100 rounded-3xl mb-6">
        <i className="ri-emotion-sad-line text-4xl text-foreground-300"></i>
      </div>
      <h1 className="text-4xl md:text-5xl font-bold text-foreground-900 font-heading mb-3">
        404
      </h1>
      <p className="text-sm md:text-base text-foreground-500 mb-8">
        抱歉，您访问的页面不存在或已被移除
      </p>
      <Link
        to="/"
        className="px-6 py-3 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-full transition-colors duration-200 whitespace-nowrap"
      >
        返回首页
      </Link>
    </div>
  );
}